module.exports = __webpack_public_path__ + "static/media/commercial.9de1b8f9.webp";